// Central place for external destinations.
// Store URLs are placeholders until official listings are live.
// Replace ONLY the values below with the real store URLs when available —
// do not change the shape of this object.
export const STORE_LINKS = {
  appStore: "#app-store-coming-soon",
  googlePlay: "#google-play-coming-soon",
};

export const SUPPORT_EMAIL = "support@velora.ai";

// True once the value is a real https store URL (not the placeholder anchor).
export const isLiveLink = (url) => typeof url === "string" && url.startsWith("http");
